import { render, staticRenderFns } from "./CenterBeam.vue?vue&type=template&id=4204cb74&"
import script from "./CenterBeam.vue?vue&type=script&lang=js&"
export * from "./CenterBeam.vue?vue&type=script&lang=js&"
import style0 from "./CenterBeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports